import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import { getDisplayAppVersion } from "@utils";
import { config } from "configurations/config";
import { environment } from "environments/environment";
import { AuthService, SharedService } from "../modules/core";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomeComponent implements OnInit, OnDestroy {
  apps = [];
  sub: any;
  loading = false;
  version: string;
  production: boolean;
  public signUpUrl: string = "";

  constructor(
    private authService: AuthService,
    private sharedService: SharedService
  ) {
    this.apps = sharedService.apps;
    this.sharedService.setTitle(config.title);
    this.sharedService.setMeta("robots", "[index,nofollow]");
  }

  ngOnDestroy() {
    this.sharedService.setMeta("robots", "noindex");
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  ngOnInit() {
    this.version = getDisplayAppVersion();
    this.production = environment.production;
    this.loading = this.authService.getUserId() ? true : false;
    this.signUpUrl = (environment.celoAuthApiEndpoint ?? "") + "/onboard";
    setTimeout(() => {
      this.loading = false;
    }, 8000);
    if (this.authService.isAuthenticated()) {
      // this.sharedService.navigateTo('conversations');
      this.sharedService.navigate(["conversations"], {
        queryParamsHandling: "merge",
      });
      return;
    }
  }

  login() {
    this.sharedService.navigateTo("/login");
  }
}
